import { doGet, doPost } from "./api";

// export const checkUserStatus = (token:any, bodyObject: any) => {
//   const Headers = {
//     // "Content-Type": "application/json",
//     Authorization: `Token ${token}`
//   };

//   console.log(bodyObject, Headers)
//   return doPost(
//     process.env.REACT_APP_BASE_URL + process.env.REACT_APP_USER_STATUS,
//     bodyObject,
//     Headers
//   );
// };

export const loginUser = (bodyObject: any) => {
  const Headers = {
    "Content-Type": "application/json",
  };
  return doPost(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_LOGIN,
    bodyObject,
    Headers
  );
};

export const registerUser = async (bodyObject: any) => {
  const Headers = {
    "Content-Type": "application/json",
  };
  // console.log(
  //   "============????>>>>",
  //   Headers,
  //   bodyObject,
  //   process.env.REACT_APP_BASE_URL + process.env.REACT_APP_REGISTER
  // );

  return doPost(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_REGISTER,
    bodyObject,
    Headers
  );
};

export const registerAuthUser = async (bodyObject: any, token: any) => {
  const Headers = { Authorization: `Token ${token}` };

  // console.log(
  //   "============????>>>>",
  //   Headers,
  //   bodyObject,
  //   process.env.REACT_APP_BASE_URL + process.env.REACT_APP_REGISTER
  // );

  return doPost(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_REGISTER,
    bodyObject,
    Headers
  );
};

export const getCreatedAddress = async (token: any) => {
  const Headers = { Authorization: `Token ${token}` };
  // console.log(
  //   "Token====>>",
  //   token,
  //   "===",
  //   process.env.REACT_APP_BASE_URL,
  //   "====",
  //   process.env.REACT_APP_CREATE_ADDRESS
  // );
  return doGet(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_CREATE_ADDRESS,
    {},
    Headers
  );
};

export const searchPinPoint = (bodyObject: any) => {
  const Headers = {};

  // console.log(
  //   "============????>>>>",
  //   Headers,
  //   bodyObject,
  //   process.env.REACT_APP_BASE_URL + process.env.REACT_APP_SEARCH
  // );

  return doPost(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_SEARCH,
    bodyObject,
    Headers
  );
};

export const forgetPassword = (bodyObject: any) => {
  const Headers = {};

  // console.log(
  //   "============????>>>>",
  //   Headers,
  //   bodyObject,
  //   process.env.REACT_APP_BASE_URL + process.env.REACT_APP_FORGET_PASS
  // );

  return doPost(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_FORGET_PASS,
    bodyObject,
    Headers
  );
};

export const resetPassword = (bodyObject: any, uuid:any, token:any) => {
  const Headers = {};

  // console.log(
  //   "============????>>>>",
  //   Headers,
  //   bodyObject,
  //   process.env.REACT_APP_BASE_URL + process.env.REACT_APP_SET_PASS + `${uuid}/${token}/` 
  // );

  return doPost(
    process.env.REACT_APP_BASE_URL + process.env.REACT_APP_SET_PASS + `${uuid}/${token}/`,
    bodyObject,
    Headers
  );
};

// export const getUserDetails = (token: any) => {
//   const Headers = { Authorization: `Token ${token}` };

//   return doGet(
//     process.env.REACT_APP_BASE_URL + process.env.REACT_APP_USER_DETAILS,
//     {},
//     Headers
//   );
// };

// export const createAlarm = async (bodyObject: any, token: any) => {
//   const Headers = { Authorization: `Token ${token}` };

//   return doPost(
//     process.env.REACT_APP_BASE_URL + process.env.REACT_APP_CREATE_ALARM,
//     bodyObject,
//     Headers
//   );
// };

// export const getAlarm = async () => {
//   const Headers = { Authorization: `Token ${"a"}` };
//   return doGet(
//     process.env.REACT_APP_BASE_URL + process.env.REACT_APP_CREATE_ALARM,
//     {},
//     Headers
//   );
// };

// export const getAlertType = async (token:any) => {
//   const Headers = { Authorization: `Token ${token}` };
//   return doGet(
//     process.env.REACT_APP_BASE_URL + process.env.REACT_APP_ALERT_TYPE,
//     {},
//     Headers
//   );
// };
